import { useEffect, useState } from 'react';
import '../../../css/SoccerTeamHomePage.css';
import ScheduleBox from '../../../components/ScheduleBox';
import RecentBox from '../../../components/RecentBox';
import RosterBox from '../../../components/RosterBox';
import PLsoccerLogos from '../../../assets/PLsoccerLogos';
import Record from '../../../components/Record';

const CrystalPalaceHome = () => {
    const [isTeamFavorite, setIsTeamFavorite] = useState(false);
    const [starredPlayers, setStarredPlayers] = useState([]);
    const [favoritesLoaded, setFavoritesLoaded] = useState(false);

    const handleSaveFavorites = async (players = starredPlayers, teamFav = isTeamFavorite) => {
        const filteredPlayers = players.filter(playerKey => playerKey.startsWith("Crystal Palace"));
        
        const fav = {
            teamName: "Crystal Palace",
            teamLogo: PLsoccerLogos["Crystal Palace"],
            isTeamFavorite: teamFav,
            players: filteredPlayers.map(player => ({
                name: player,
                isFavorite: true
            }))
        };

         try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/favorites/save`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify(fav),
            });

        } catch(err) {
            console.error("Error saving favorites: ", err);
        }
    };

    useEffect(() => {
            const fetchFavorites = async () => {
                try {
                        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/favorites/get?team=Crystal Palace`, {
                        method: "GET",
                        headers: { "Content-Type": "application/json" },
                        credentials: "include",
                    });
        
                    if (!res.ok) {
                        console.log("No favorites found or error fetching");
                        setFavoritesLoaded(true);
                        return;
                    }
                    const data = await res.json();
        
                    // highlight team star
                    setIsTeamFavorite(data.team?.isFavorite || false);
        
                    // highlight player stars
                    const playerKeys = data.players
                        .filter(p => p.isFavorite && p.name.startsWith("Crystal Palace"))
                        .map(p => p.name);  
                    setStarredPlayers(playerKeys);
                    setFavoritesLoaded(true);
    
                } catch (err) {
                    console.error("Error fetching favorites", err);
                }
            };
        
            fetchFavorites();
        }, []);

    return (
        <div>
            <section className="soccer-top-row">
                <section className="soccer-team-info">
                    <img
                        className="soccer-team-logo"
                        src={PLsoccerLogos["Crystal Palace"]}
                        alt="Crystal Palace"
                    />
                    <div className="soccer-team-text">
                        <div className="soccer-title-row">
                            <h1>Crystal Palace</h1>
                            <button
                                type="button"
                                className="soccer-favorite-btn"
                                onClick={() => {
                                    const newVal = !isTeamFavorite;
                                    setIsTeamFavorite(newVal);
                                    handleSaveFavorites(starredPlayers, newVal); 
                                }}
                                aria-label="Toggle favorite"
                            >
                                {isTeamFavorite ? '★' : '☆'}
                            </button>
                        </div>
                        <p><span className="soccer-label">Record:</span> <Record name="Crystal Palace" /></p>
                        <p><span className="soccer-label">Stadium:</span> Selhurst Park</p>
                        <p><span className="soccer-label">Head Coach / Manager:</span> Oliver Glasner</p>
                        <p><span className="soccer-label">Assistant Staff:</span> Michael Angerschmid, Ronald Brunmayr, Emanuel Pogatetz, Paddy McCarthy</p>
                    </div>
                </section>
            </section>

            <div className="soccer-team-content">
                <section className="soccer-left-content">
                    <h2>Roster</h2>
                    {favoritesLoaded && (
                    <RosterBox
                        teamName="Crystal Palace"
                        sport="soccer"
                        favoritePlayers={starredPlayers || []} 
                        onFavoriteChange={(updatedPlayers) => {
                            setStarredPlayers(updatedPlayers);
                            handleSaveFavorites(updatedPlayers, isTeamFavorite);
                        }}
                    />
                    )}
                </section>

                <section className="soccer-middle-content">
                    <h2>Recent Matches</h2>
                    <RecentBox teamName="Crystal Palace" />

                    <h2>Upcoming Matches</h2>
                    <ScheduleBox teamName="Crystal Palace" />
                </section>

                <section className="soccer-right-content">
                    <h2>Fun Facts</h2>
                    <div className="soccer-box">
                        <p>• Their original nickname was “The Glaziers” before changing to “The Eagles” in 1973</p>
                        <br />
                        <p>• Have been promoted to the top flight a record 5 times via the playoffs</p>
                        <br />
                        <p>• The club’s mascot is an eagle named Kayla where she flies around Selhurst Park before games</p>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default CrystalPalaceHome;